import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@orisini/ui/context/AuthContext'

/**
 * Gerbang sesi untuk halaman yang butuh login.
 *
 * Di orisini.com tujuannya route internal `/login`; di SPA produk pola yang
 * dipakai berbeda — mereka mengarahkan ke `loginUrl()` yang menunjuk ke
 * orisini.com, karena produk tidak punya halaman masuk sendiri.
 */
export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { status } = useAuth()
  const location = useLocation()

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    )
  }

  if (status === 'anonymous') {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />
  }

  return <>{children}</>
}
